import { Outlet } from 'react-router-dom';

export const AccountRootLayout: React.FC = () => {
  return <Outlet />;
};
